module.exports = __webpack_public_path__ + "img/600749.f8931661.jpg";